
angular.module('tf.directives')

    .directive('workEmail',  function() {
        return {
            restrict        :'A',
            link: function (scope, element, attrs) {
                var rejectEmails = /@gmail|@hotmail|@yahoo/;

                element.on('input', function() {
                    if (element[0].validity.valid && element[0].value.match(rejectEmails)) {
                        element[0].setCustomValidity("Please enter a valid work email");
                        element[0].validity.valid = false;
                    } else {
                        element[0].setCustomValidity("");
                    }
                });

            }
        };
    })
;



